"use client";

import React, { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { normalizedDomain } from "@/sanity/env";

const excludedPaths = [
  "/studio",
  "/shop",
  "/vsl-short",
  "/vsl-long",
  "trading-ausbildung",
  "/customers",
  "/bastian-keller",
];

// Deployments that never show the widget; bastiankeller.com serves one page at "/", so it cannot be a path entry.
const excludedDomains = ["bastiankeller"];

const IntercomClientComponent: React.FC = () => {
  const pathname = usePathname();
  const wasShutdown = useRef(false);

  useEffect(() => {
    const isExcluded =
      excludedDomains.includes(normalizedDomain) || excludedPaths.some((path) => pathname.includes(path));

    if (isExcluded) {
      // @ts-ignore
      if (window.Intercom) {
        // @ts-ignore
        window.Intercom("shutdown");
        wasShutdown.current = true;
      }
      return;
    }

    const intercomSettings: any = {
      api_base: "https://api-iam.intercom.io",
      app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
    };

    // @ts-ignore
    window.intercomSettings = intercomSettings;

    // @ts-ignore
    if (window.Intercom) {
      if (wasShutdown.current) {
        // @ts-ignore
        window.Intercom("boot", intercomSettings);
        wasShutdown.current = false;
      } else {
        // @ts-ignore
        window.Intercom("reattach_activator");
        // @ts-ignore
        window.Intercom("update", intercomSettings);
      }
    } else {
      const intercomScript = document.createElement("script");
      if (!intercomScript) {
        console.error("Intercom script could not be created.");
        return;
      }
      intercomScript.type = "text/javascript";
      intercomScript.async = true;
      intercomScript.src = `https://widget.intercom.io/widget/${process.env.NEXT_PUBLIC_INTERCOM_APP_ID}`; // Ensure this matches your Intercom app ID.
      // @ts-ignore
      intercomScript.onload = () => window.Intercom("update", intercomSettings);
      document.body.appendChild(intercomScript);
    }
  }, [pathname]);
  return null; // This component does not render anything visually.
};

export default IntercomClientComponent;
